<template>
  <div>
    <el-form :inline="true" :model="searchForm" class="demo-form-inline">
      <!-- 筛选下拉配置渲染，便于统一维护 -->
      <el-select
          v-for="select in formSelects"
          :key="select.key"
          v-model="searchForm[select.model]"
          :placeholder="select.placeholder"
          :class="select.className"
          @change="handleSelectChange(select)">
        <el-option v-for="item in select.options"
                   :key="item.value"
                   :label="item.label"
                   :value="item.value">
        </el-option>
      </el-select>
      <el-form-item>
        <el-input v-model="searchForm.keyword"
                  class="search-input"
                  placeholder="请输入患者名称，如：王"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit" class="primary-search-btn">查询
        </el-button>
      </el-form-item>
    </el-form>

    <el-card class="box-card" shadow="hover">
      <div slot="header" class="clearfix" style="border: none">
        <i class="el-icon-card-header"></i>
        <span>数据列表一览</span>
      </div>
      <el-table v-loading="listLoading" :data="resultTbl" :header-cell-style="tableHeaderStyle"
                :row-class-name="tableRowClassName"
                style="width: 100%;">
        <!-- 表格列配置化，减少重复 DOM -->
        <template v-for="column in tableColumns">
          <el-table-column
              v-if="!column.isAction"
              :key="column.key + '-data'"
              v-bind="column.columnProps">
          </el-table-column>
          <el-table-column v-else :key="column.key + '-action'" :label="column.label" :width="column.width">
            <template slot-scope="scope">
              <el-button @click="open_detail(scope.row)" type="text" size="small" class="action-text-btn">
                {{ column.actionLabel }}
              </el-button>
            </template>
          </el-table-column>
        </template>
      </el-table>

      <!-- 不展示总页数/总条数：用「本页是否满页」推断是否还有下一页，避免依赖 total 统计（接口慢时常出在 count） -->
      <div class="simple-pager" v-if="listLoaded">
        <el-select
          v-model="searchForm.page_size"
          class="pager-page-size"
           size="small"
          @change="handleSizeChange">
          <el-option
            v-for="size in paginationConfig.pageSizes"
            :key="size"
            :label="`${size}条/页`"
            :value="size"
          />
        </el-select>
        <el-button
          type="default"
          size="small"
          class="pager-nav-btn"
          :disabled="searchForm.page_num <= 1 || listLoading"
          @click="goPrevPage">
          上一页
        </el-button>
        <el-button
          type="default"
          size="small"
          class="pager-nav-btn pager-next-green"
          :disabled="!canGoNext || listLoading"
          @click="goNextPage">
          下一页
        </el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import '@/assets/css/main.css';
import {Role} from "@/role";

const API_HOST = process.env.VUE_APP_API_HOST;
const JSON_HEADERS = {"content-type": "application/json"};
const FORM_SELECT_CONFIGS = [
  {
    key: 'shengqu',
    model: 'shengqu',
    placeholder: '请选择省区',
    className: 'select-compact select-offset',
    optionsKey: 'options_shengqu',
    onChange: 'get_diban_zssy'
  },
  {
    key: 'diban',
    model: 'diban',
    placeholder: '请选择地办',
    className: 'select-compact select-offset',
    optionsKey: 'options_diban'
  }
];
const TABLE_COLUMNS = [
  {
    key: 'index',
    columnProps: {type: 'index', prop: 'order', label: '序号', width: '50', align: 'center'}
  },
  {
    key: 'patient_id',
    hidden: true,
    columnProps: {prop: 'patient_id', label: 'patient_id', align: 'center'}
  },
  {
    key: 'patient_name',
    columnProps: {prop: 'patient_name', label: '患者姓名', align: 'left', showOverflowTooltip: true}
  },
  {
    key: 'patient_birthday',
    columnProps: {prop: 'patient_birthday', label: '生日', align: 'left', showOverflowTooltip: true}
  },
  {key: 'patient_phone', columnProps: {prop: 'patient_phone', label: '手机号', align: 'left'}},
  {key: 'patient_gender', columnProps: {prop: 'patient_gender', label: '性别', align: 'left'}},
  {key: 'province_name', columnProps: {prop: 'province_name', label: '省份', align: 'left'}},
  {key: 'city_name', columnProps: {prop: 'city_name', label: '市区', align: 'left'}},
  {
    key: 'action',
    isAction: true,
    label: '操作',
    width: '160',
    actionLabel: '详情'
  }
];
const PAGINATION_CONFIG = {
  pageSize: 20,
  pageSizes: [20, 50, 100, 200, 300, 400]
};

export default {
  name: "PatientList",
  data() {
    return {
      searchForm: {
        keyword: '',
        page_num: 1,
        shengqu: "湖北",
        diban: "",
        table_name: "",
        page_size: 20,
      },
      // 下拉选项默认置空数组，避免渲染期报错
      options_shengqu: [],
      options_diban: [],
      resultTbl: [],
      result_columns: [],
      hit_info: "",
      /** 列表请求中，用于表格 v-loading 与分页按钮禁用 */
      listLoading: false,
      /** 是否已完成至少一次列表请求（用于展示底部分页条） */
      listLoaded: false,
      /**
       * 是否允许点「下一页」：本页返回条数等于 page_size 时认为可能还有后续页（不查 total）。
       * 若最后一页恰好满页，会多一次请求得到空表，此时 canGoNext 为 false。
       */
      canGoNext: false,
      // 表头样式统一配置
      tableHeaderStyle: {background: '#363944', color: 'white', border: 'none'},
      // 分页配置集中管理
      paginationConfig: PAGINATION_CONFIG
    }
  },
  mounted() {
    this.get_shengqu();
    this.get_diban_zssy();
    this.onSubmit1();
  },
  computed: {
    isDemo: function () {
      return this.$store.getters.user_role === Role.Demo
    },
    // 表单配置与选项联动，方便模板直接渲染
    formSelects() {
      return FORM_SELECT_CONFIGS.map((config) => ({
        ...config,
        options: this[config.optionsKey] || []
      }));
    },
    // 表格列配置集中管理，同时处理条件列
    tableColumns() {
      const showAction = this.searchForm.table_name !== 'western_medicine_public';
      return TABLE_COLUMNS.filter((column) => {
        if (column.hidden) {
          return false;
        }
        if (column.isAction) {
          return showAction;
        }
        return true;
      });
    }
  },
  methods: {
    // 根据配置触发表单联动逻辑
    handleSelectChange(select) {
      if (select.onChange && typeof this[select.onChange] === 'function') {
        this[select.onChange]();
      }
    },
    get_shengqu() {
      this.$http.get(API_HOST + "/get_shengqu").then((res) => {
        this.options_shengqu = res.data.data
      })
    },
    get_diban_zssy() {
      this.searchForm.diban = ''
      this.$http.get(API_HOST + "/get_diban?province_id=" + this.searchForm.shengqu).then((res) => {
        this.options_diban = res.data.data
      })
    },
    do_mixup(row) {
      this.$http.post(API_HOST + "/do_mixup", row, JSON_HEADERS).then((res) => {
        const result = res.data.data;
        for (let key in result) {
          row[key] = result[key]
        }
      })
    },
    /**
     * 在新窗口打开患者详情页（Basic），避免离开当前列表。
     * @param {{ patient_id: string }} row 当前行数据，需含 patient_id
     */
    open_detail(row) {
      const target = this.$router.resolve({
        path: '/patient/basic',
        query: { patient_id: row.patient_id },
      });
      window.open(target.href, '_blank', 'noopener,noreferrer');
    },
    handleChangeDbSel(val) {
      this.searchForm.db_name = val.key;
      this.onSubmit1();
    },
    /**
     * 修改每页条数后重新拉取列表，并回到第一页。
     * @param {number} val 新的每页条数（与 el-select change 一致）
     */
    handleSizeChange(val) {
      this.searchForm.page_size = val;
      this.searchForm.page_num = 1;
      this.onSubmit1();
    },
    /**
     * 翻到上一页并请求列表；无 total，仅依赖当前页码。
     */
    goPrevPage() {
      if (this.searchForm.page_num <= 1 || this.listLoading) {
        return;
      }
      this.searchForm.page_num -= 1;
      this.onSubmit1();
    },
    /**
     * 翻到下一页并请求列表；仅当 canGoNext 为 true 时由模板禁用外仍会校验。
     */
    goNextPage() {
      if (!this.canGoNext || this.listLoading) {
        return;
      }
      this.searchForm.page_num += 1;
      this.onSubmit1();
    },
    /** 条件查询：从第一页重新拉取 */
    onSubmit() {
      this.searchForm.page_num = 1;
      this.onSubmit1();
    },
    /**
     * 请求患者列表当前页数据；不依赖 total_record，用本页条数更新 canGoNext。
     */
    onSubmit1() {
      this.listLoading = true;
      this.$http.post(API_HOST + "/patient/patient_list",
          this.searchForm, JSON_HEADERS).then((res) => {
        this.resultTbl = res.data.search_result || [];
        this.canGoNext = this.resultTbl.length === this.searchForm.page_size;
      }).catch(() => {
        this.resultTbl = [];
        this.canGoNext = false;
      }).finally(() => {
        this.listLoading = false;
        this.listLoaded = true;
      });
    },

    // 表格斑马纹样式
    tableRowClassName({rowIndex}) {
      return rowIndex % 2 === 1 ? 'warning-row1' : 'success-row1';
    },
  }
}


</script>
<style scoped>
.el-form {
  margin-top: 10px;
  /* text-align: center; */
}

.el-form-item {
  text-align: center;
}

.select-compact {
  width: 100px;
}

.select-offset {
  margin-left: 20px;
}

.search-input {
  width: 250px;
  margin-left: 20px;
  background-color: #4B4F56;
  color: white;
}

.primary-search-btn {
  background-color: #2ECD81;
  border-color: #2ECD81;
  color: white;
}

.action-text-btn {
  color: #5CEAA8;
}

:deep(.el-table tbody tr:hover) {
  color: black !important
}

:deep(.el-table .warning-row1) {
  background: #363944;
}

:deep(.el-table .warning-row1 > td) {
  border: none;
}

:deep(.el-table .success-row1) {
  background: #3C3F4A;
}

:deep(.el-table .success-row1 > td) {
  border: none;
}

:deep(.el-card .el-card__header) {
  border-bottom: none;
  height: 40px;
  padding: 10px 20px;
}

:deep(.el-card .el-card__body) {
  background-color: #363944;
}


:deep(.el-tabs__item) {
  color: white !important;
  font-size: 20px;
}

:deep(.el-tabs__item.is-active) {
  color: white !important;
  font-size: 20px;
}

:deep(.el-tabs__active-bar) {
  background-color: #68F5B9 !important;

}

.simple-pager {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 12px;
}

.pager-page-size {
  width: 120px;
  margin-right: 12px;
}

.pager-nav-btn {
  margin-right: 8px;
}

/* 下一页：保持 type=default，用与查询按钮一致的绿色 */
.pager-next-green {
  background-color: #2ecd81 !important;
  border-color: #2ecd81 !important;
  color: #fff !important;
}

.pager-next-green:hover:not(.is-disabled),
.pager-next-green:focus:not(.is-disabled) {
  background-color: #26b574 !important;
  border-color: #26b574 !important;
  color: #fff !important;
}

.pager-next-green.is-disabled {
  background-color: #3a5248 !important;
  border-color: #4a5c54 !important;
  color: rgba(255, 255, 255, 0.45) !important;
}
</style>
